import { IAddNewProduct, IUpdateProduct } from 'src/redux/products/productsSlice';
import { apiClient } from './backendURL';

export const getAllProductsAPI = () => apiClient.get('product/getProducts');

export const updateProductImageAPI = (token: any, img: File, id: string) => {
    const formData = new FormData();
    formData.append('file', img);

    apiClient.put('product/updateProductImage', formData, {
        headers: {
            authorization: token,
            'Content-Type': 'multipart/form-data',
        },
        params: {
            id: id,
        },
    });
};

export const updateProductAPI = (data: IUpdateProduct, token: any) => {
    const formData = new FormData();
    formData.append('id', data.id);
    formData.append('name', data.name);
    formData.append('price', String(data.price));
    formData.append('category', data.category);
    formData.append('sub_category', data.sub_category || '');
    formData.append('description', data.description);
    formData.append('specification', data.specification || '');
    formData.append('vendor_name', data.vendor_name || '');
    formData.append('vendor_address', data.vendor_address || '');
    formData.append('status', data.status);
    formData.append('quantity', String(data.quantity));
    if (data.files && data.files.length > 0) {
        data.files.forEach(file => formData.append('files', file));
    }
    // updatedAt is usually handled by backend, skipping

    return apiClient.post('product/updateProduct', formData, {
        headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
        },
        params: {
            id: data.id,
        },
    });
};

export const addNewProductAPI = (data: IAddNewProduct, token: any) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('category', data.category);
    formData.append('sub_category', data.sub_category || '');
    formData.append('price', String(data.price));
    formData.append('quantity', String(data.quantity));
    formData.append('description', data.description);
    formData.append('specification', data.specification || '');
    formData.append('vendor_name', data.vendor_name || '');
    formData.append('vendor_address', data.vendor_address || '');
    if (data.files && data.files.length > 0) {
        data.files.forEach(file => formData.append('files', file));
    }

    return apiClient.post('product/addProduct', formData, {
        headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const deleteProductAPI = (id: string, token: any) =>
    apiClient.delete('product/deleteProduct', {
        headers: {
            Authorization: token,
        },
        params: {
            id: id,
        },
    });

export const getVendorProductsAPI = (token: any) =>
    apiClient.get('product/getVendorProducts', {
        headers: {
            Authorization: token,
        },
    });

export const getLatestProductsAPI = (limit: number = 4) =>
    apiClient.get('product/getLatestProducts', {
        params: { limit },
    });
